import { shopChoices } from '../../../http/api/UserApi';
import { useEffect, useState } from 'react';

const useShopItems = () => {
  const [shopList, setShopList] = useState([]);
  useEffect(() => {
    fetchShopChoices();
  }, []);

  const fetchShopChoices = async () => {
    const shop = await shopChoices();
    setShopList(shop.shopChoicesInfo);
  };

  return shopList;
};

export default useShopItems;